import {
   Radio as MantineRadio,
   RadioProps as MantineRadioProps,
} from '@mantine/core'

export const Radio = ({ ...props }: MantineRadioProps) => {
   return (
      <MantineRadio
         {...props}
         color="#A684FF"
         classNames={{
            label: 'text-white font-medium text-base',
         }}
      />
   )
}
